import { useFlag } from '@unleash/proxy-client-vue'

export const useWhatsAppButtonState = () => {
  const globalStore = useGlobalStore()
  const flagsReady = inject('flagsReady') as Ref<boolean>
  const isWhatsAppButtonToggleFeatureEnabled = useFlag('storefront.whatsapp-button-toggle')

  const isVisible = computed(() => {
    if (!flagsReady.value) {
      return false
    }

    if (!isWhatsAppButtonToggleFeatureEnabled.value) {
      return true
    }

    if (!globalStore.isCheckoutEnabled) {
      return true
    }

    return globalStore.store.checkoutSettings?.isWhatsAppButtonEnabled
  })

  return {
    isVisible,
  }
}
